import { EditorPlugin } from 'roosterjs-editor-core';
import EditorPluginEx from '../store/schema/EditorPluginEx';

export default function isEditorPluginEx(plugin: EditorPlugin): plugin is EditorPluginEx {
    return plugin && !!(plugin as EditorPluginEx).setPluginUtils;
}
